var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8066_23851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8066_23851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.125H0.5V23.8426H24.5V0.125Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8066_23851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8066_23851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.125H0.5V23.8426H24.5V0.125Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8066_23851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8066_23851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.407349H0.782353V23.8426H24.5V0.407349Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8066_23851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8066_23851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.407349H0.782353V23.8426H24.5V0.407349Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8066_23851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8066_23851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.407349H0.782353V23.8426H24.5V0.407349Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8066_23851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5236 12.125C22.5236 17.5179 18.0991 21.8897 12.6412 21.8897C7.18332 21.8897 2.75882 17.5179 2.75882 12.125C2.75882 6.73211 7.18332 2.36029 12.6412 2.36029C18.0991 2.36029 22.5236 6.73211 22.5236 12.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12.125C24.5 18.5965 19.1907 23.8426 12.6412 23.8426C6.09174 23.8426 0.782353 18.5965 0.782353 12.125C0.782353 5.65352 6.09174 0.407349 12.6412 0.407349C19.1907 0.407349 24.5 5.65352 24.5 12.125Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2153 12.125C23.2153 17.8954 18.4811 22.5732 12.6412 22.5732C6.80127 22.5732 2.06706 17.8954 2.06706 12.125C2.06706 6.3546 6.80127 1.67676 12.6412 1.67676C18.4811 1.67676 23.2153 6.3546 23.2153 12.125Z",
    fill: "#A50000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5236 12.125C22.5236 17.5179 18.0991 21.8897 12.6412 21.8897C7.18332 21.8897 2.75882 17.5179 2.75882 12.125C2.75882 6.73211 7.18332 2.36029 12.6412 2.36029C18.0991 2.36029 22.5236 6.73211 22.5236 12.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.639 12.6805L7.95256 9.82051L8.36982 9.15653L12.6434 11.7648L18.2324 8.37317L18.6453 9.04153L12.639 12.6805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8271 12.125C13.8271 12.7721 13.2961 13.2968 12.6412 13.2968C11.9862 13.2968 11.4553 12.7721 11.4553 12.125C11.4553 11.4778 11.9862 10.9532 12.6412 10.9532C13.2961 10.9532 13.8271 11.4778 13.8271 12.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72035 4.31892L8.24336 4.02056L9.08995 5.46944L8.56694 5.7678L7.72035 4.31892Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42159 7.79639L4.72355 7.27961L6.18988 8.11612L5.88793 8.6329L4.42159 7.79639Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32541 11.8407H5.01858V12.4375H3.32541V11.8407Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42151 16.4828L5.88784 15.6462L6.1898 16.163L4.72347 16.9995L4.42151 16.4828Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72121 19.9628L8.5678 18.5139L9.09081 18.8123L8.24422 20.2611L7.72121 19.9628Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3381 19.672H12.9421V21.3451H12.3381V19.672Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1893 18.8119L16.7123 18.5137L17.5587 19.9627L17.0356 20.261L16.1893 18.8119Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0913 16.1646L19.3932 15.6478L20.8597 16.484L20.5578 17.0009L19.0913 16.1646Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2638 11.8407H21.957V12.4375H20.2638V11.8407Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1623 8.14474L20.6353 7.30824L20.9373 7.82738L19.4642 8.66389L19.1623 8.14474Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1889 5.47L17.0354 4.02113L17.5584 4.31949L16.7119 5.76836L16.1889 5.47Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1317 3.14797C12.0595 3.14751 11.9904 3.17657 11.9406 3.22826L11.5541 3.60798C11.4483 3.71299 11.4483 3.88274 11.5541 3.98775L12.6522 5.06185L13.7502 3.98775C13.856 3.88274 13.856 3.71299 13.7502 3.60798L13.3417 3.22826C13.292 3.17657 13.2229 3.14751 13.1507 3.14797C13.0781 3.14843 13.0086 3.17729 12.9574 3.22826L12.6412 3.54073L12.3249 3.22826C12.2744 3.17646 12.2045 3.14743 12.1317 3.14797Z",
    fill: "#CC0000"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8066_23851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.7176,
    fill: "white",
    transform: "translate(0.5 0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.70caf17eff18251cfe3d1c221cd7d152.svg";
export { ForwardRef as ReactComponent };